import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import USPositionFormGroup from "./USPositionFormGroup";
import SearchField from "../SearchField/SearchField";
import useUSPosition from "../../hooks/useUSPosition";
import {
  handleFigureChange,
  handleFigureBlur,
  handleInputSelect,
  addEdits,
  handlePercentageChange,
  handlePercentageBlur,
} from "./utils/inputhandlers";
import useUSUndo from "../../hooks/useUSUndo";
import useGlobalParams from "../../hooks/useGlobalParams";

const PositionsUSAFigures = ({
  ignoreEnter,
  setShowcalculator,
  showcalculator,
  resetOutbound,
  resetOceanfreight,
  resetCustoms,
  resetInbound,
  clearfield,
  // handleInputSelect,
}) => {
  // Load context values
  const { USposition, setUSposition, setUSpositionData } = useUSPosition();
  const { positionEdits, editID, setEditID, editingField, setEditingField, undoList, inputRefs } = useUSUndo();
  const { globalparams } = useGlobalParams();

  // Local handleFigureChange and handleFigureBlur functions to allow shorthand in input component.
  const localHandleFigureChange = (e, type, dec = 2) => {
    handleFigureChange(e, type, setUSposition, setUSpositionData, setEditingField, dec);
  };
  const localHandleFigureBlur = (e, type, dec = 2) => {
    handleFigureBlur(
      e,
      type,
      setUSposition,
      positionEdits,
      editID,
      setEditID,
      editingField,
      setEditingField,
      undoList,
      dec
    );
  };
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEdits,
      editID,
      setEditID,
      setUSposition,
      setUSpositionData,
      addEdits,
      undoList,
      origin,
      destination,
      globalparams
    );
  };

  return (
    <>
      <fieldset style={{ height: "90px" }}>
        <legend>Figures:</legend>
        <div className='form-group'>
          <label>Quantity (mt):</label>
          <div className='USqtyandtolerance'>
            <input
              required
              type='text'
              name='quantity'
              value={USposition?.quantity || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
              onChange={(e) => localHandleFigureChange(e, "decimal")}
              onBlur={(e) => localHandleFigureBlur(e, "decimal")}
              ref={(el) => (inputRefs.current["quantity"] = el)}
            />
            <p>+/-</p>
            <input
              required
              style={{ minWidth: "35px", maxWidth: "45px" }}
              value={USposition?.tolerance || ""}
              onFocus={(e) => e.target.select()}
              // onChange={(e) => handlePercentageChange(e, setUSposition, setUSpositionData, 2)}
              onChange={(e) => localHandleFigureChange(e, "percent", 2)}
              // onBlur={(e) => handlePercentageBlur(e, setUSposition, 2)}
              onBlur={(e) => localHandleFigureBlur(e, "percent", 2)}
              onKeyDown={ignoreEnter}
              name='tolerance'
              placeholder='% ...'
              ref={(el) => (inputRefs.current["tolerance"] = el)}
            />
          </div>
        </div>
        <USPositionFormGroup labelname={"# Pallets"} inputname={"numpallets"} inputtype={"decimal"} />
      </fieldset>
      <fieldset>
        <legend>Costs (per mt):</legend>
        <USPositionFormGroup labelname={"Material Cost"} inputname={"materialcost"} inputtype={"currency"} />
        <USPositionFormGroup labelname={"P Commission"} inputname={"pcomission"} inputtype={"currency"} />
        <USPositionFormGroup labelname={"P Finance Cost"} inputname={"pfinancecost"} inputtype={"currency"} />
        <div className='form-group'>
          <label>
            Outbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("outboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='outboundcost'
            value={USposition?.outboundcost || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "outboundcost" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USPositionFormGroup labelname={"Payload (mt/FCL)"} inputname={"outpayload"} inputtype={"decimal"} />
            <USPositionFormGroup labelname={"Drayage per FCL"} inputname={"outdrayage"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Loading Fee per FCL"} inputname={"loading"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Collect Charges"} inputname={"outcollectcharges"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Outbound others"} inputname={"outboundothers"} inputtype={"currency"} />
            <USPositionFormGroup readOnly={true} labelname={"Total Outbound"} inputname={"totaloutbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetOutbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Ocean Freight:
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("oceanfreight");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='freightpmt'
            value={USposition?.freightpmt || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "oceanfreight" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USPositionFormGroup labelname={"Payload (mt)"} inputname={"oceanpayload"} inputtype={"decimal"} />
            <USPositionFormGroup labelname={"Total Freight"} inputname={"oceanfreight"} inputtype={"currency"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                resetOceanfreight();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Import Customs Fee:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("importcustomsfee");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='importcustomsfee'
            value={USposition?.importcustomsfee || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "importcustomsfee" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USPositionFormGroup labelname={"Quantity"} inputname={"quantity"} inputtype={"decimal"} />
            <USPositionFormGroup labelname={"Material Cost/mt"} inputname={"materialcost"} inputtype={"currency"} />
            <USPositionFormGroup readOnly={true} labelname={"Material Value"} inputname={"materialvalue"} />
            <USPositionFormGroup labelname={"General Duty(%)"} inputname={"generaldutyimp"} inputtype={"percent"} />
            <USPositionFormGroup
              labelname={"Additional Duty(%)"}
              inputname={"additionaldutyimp"}
              inputtype={"percent"}
            />
            <USPositionFormGroup readOnly={true} labelname={"Total Duty(%)"} inputname={"totalduty"} />
            <USPositionFormGroup readOnly={true} labelname={"Duty Fee"} inputname={"dutyfee"} />
            <USPositionFormGroup labelname={"Harbor Fee(%)"} inputname={"harborfeepct"} inputtype={"percent"} />
            <USPositionFormGroup readOnly={true} labelname={"Harbor Fee"} inputname={"harborfee"} />
            <USPositionFormGroup
              labelname={"Merch. Proc. Fee(%)"}
              inputname={"merchprocfeepct"}
              inputtype={"percent"}
            />
            <USPositionFormGroup readOnly={true} labelname={"Merch. Proc. Fee"} inputname={"merchprocfee"} />
            <USPositionFormGroup labelname={"Flat fee"} inputname={"flatfee"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"TSCA"} inputname={"tsca"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"ISF"} inputname={"isf"} inputtype={"currency"} />
            <USPositionFormGroup readOnly={true} labelname={"Total Entry Fee"} inputname={"totalcentryfee"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetCustoms();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Inbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("inboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='inboundcost'
            value={USposition?.inboundcost}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "inboundcost" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <USPositionFormGroup labelname={"Payload (mt/FCL)"} inputname={"inpayload"} inputtype={"decimal"} />
            <USPositionFormGroup labelname={"Drayage per FCL"} inputname={"indrayage"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Loading Fee per FCL"} inputname={"unloading"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Collect Charges"} inputname={"incollectcharges"} inputtype={"currency"} />
            <USPositionFormGroup labelname={"Outbound others"} inputname={"inboundothers"} inputtype={"currency"} />
            <USPositionFormGroup readOnly={true} labelname={"Total Inbound"} inputname={"totalinbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetInbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <USPositionFormGroup labelname={"Inspection Cost"} inputname={"inspectioncost"} inputtype={"currency"} />
        <USPositionFormGroup labelname={"Legal"} inputname={"legal"} inputtype={"currency"} />
        <USPositionFormGroup labelname={"Pallets"} inputname={"pallets"} inputtype={"currency"} />
        <USPositionFormGroup labelname={"Other"} inputname={"other"} inputtype={"currency"} />
        <USPositionFormGroup
          readOnly={true}
          labelname={"Total Cost"}
          inputname={"totalcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
        <div style={{ marginTop: "1.5rem" }} className='form-group'>
          <label style={{ position: "relative" }}>
            Insurance Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("insurance");
              }}
            />
          </label>
          <input
            type='text'
            name='insurancecost'
            readOnly
            value={USposition.insurancecost || ""}
            onKeyDown={ignoreEnter}
          />
        </div>
        {showcalculator === "insurance" && (
          <div className='USbottompopupcalculator' style={{ position: "absolute" }}>
            <div className='form-group'>
              <label htmlFor=''>S Incoterms:</label>
              <SearchField
                required={true}
                searchURL='/api/positions/getsincoterms'
                value={USposition?.sincoterm || ""}
                valueName='sincoterm'
                valueID='sincotermID'
                customplaceholder='S Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
                clearfield={clearfield}
              />
            </div>
            <USPositionFormGroup labelname={"Insurance Rate %"} inputname={"insurancerate"} inputtype={"percent"} />
            <USPositionFormGroup labelname={"Insurance Factor"} inputname={"insurancefactor"} inputtype={"decimal"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <USPositionFormGroup readOnly={true} labelname={"Interest Cost"} inputname={"interestcost"} />
        <USPositionFormGroup
          readOnly={true}
          labelname={"Purchase Price (inc. I&I)"}
          inputname={"priceafterintins"}
          rowStyle={{ marginTop: "1rem" }}
        />
      </fieldset>
    </>
  );
};

export default PositionsUSAFigures;
